module.exports = "https://static.energy5.com/_next/static/images/exploreEnergy5-ca39b587281adee45d17f2545bb0bf0a.webp";